import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { AngularMaterialModule } from '@shared/angular-material.module';
import { SharedModule } from '@shared/shared.module';
import { AccountCreatedPageComponent } from './components/account-created-page/account-created-page.component';
import { ActivateUserPageComponent } from './components/activate-user-page/activate-user-page.component';
import { CreateAccountPageComponent } from './components/create-account-page/create-account-page.component';
import { ForgotPasswordPageComponent } from './components/forgot-password-page/forgot-password-page.component';

@NgModule({
	declarations: [
		AccountCreatedPageComponent,
		ActivateUserPageComponent,
		ForgotPasswordPageComponent,
		CreateAccountPageComponent
	],
	imports: [
		AngularMaterialModule,
		CommonModule,
		ReactiveFormsModule,
		RouterModule,
		SharedModule
	]
})
export class UsersModule { }
